import { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useProcess } from '../../stores/process/process/ProcessAction';
import { useProcessBOM } from '../../stores/process/processbom/ProcessBOMAction';
import { useProcessAPI } from '../../api/process/useProcessAPI';
import { processColumns, processSearchFormFields, processFormFields, processBOMColumns, processBOMFormFields } from './context';

import ConfirmModal from '../../components/Modal/Confirm/ConfirmModal';
import ExcelImportResultModal from '../../components/Modal/ExcelImportResult/ExcelImportResultModal';
import FileManagement from '../../components/Modal/File/FileManagement';
import Search from '../../components/Search/Search';
import Table from '../../components/Table/Table/Table';
import BaseModal from '../../components/Modal/Base/BaseModal';
import CrudModal from '../../components/Modal/Crud/CrudModal';

import { FaInfo } from 'react-icons/fa';
import { PiFloppyDiskBold } from "react-icons/pi";
import { FaIndustry, FaWarehouse } from 'react-icons/fa';
import './ProcessManagement.css';

const ProcessManagement = () => {
  
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.data);
  const process = useSelector((state) => state.process);
  const processBOM = useSelector((state) => state.processBOM);
  const processApi = useProcess();
  const processBOMApi = useProcessBOM();
  const processDirectApi = useProcessAPI();
  const [selectedRows, setSelectedRows] = useState([]);


  const [clickedRow, setClickedRow] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [modalTitle, setModalTitle] = useState('');
  const [importResult, setImportResult] = useState(null);
  const [importResultOpen, setImportResultOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  // const openModal = (type, category, row = null) => {
  //   setModalCategory(category);
  //   if (category === 'process') {
  //     setModalTitle(<><FaIndustry style={{ marginRight: '8px' }} /> 공정 </>);
  //   }
  //   else if (category === 'processBOM') {
  //     setModalTitle(<><FaWarehouse style={{ marginRight: '8px' }} /> 공정 BOM </>);
  //   }
  //   setIsOpen(true);
  //   setContent(
  //   <CrudModal
  //     type={type}
  //     formFields={getFormFields(category)}
  //     formDatas={row || {}}
  //     onClose={closeModal}
  //     onSubmit={getSubmitFunction(type, category)}
  //   />)
  // };
  // type 1 : 등록, 2 : 수정
// category : 1 = 공정, 2 = 공정 BOM
  const openModal = (type, category, row = null) => {
    let action;
    let formFields
    if(category === 1){
      formFields = processFormFields;
      if(type === 1){
        setModalTitle(<><FaIndustry style={{ marginRight: '8px' }} /> 공정 등록</>)
        action = addProcess;
      } else {
        setModalTitle(<><FaIndustry style={{ marginRight: '8px' }} /> 공정 수정</>)
        action = updateProcess;
      }
    } else if(category === 2){
      formFields = processBOMFormFields
      if(type === 1){
        setModalTitle(<><FaIndustry style={{ marginRight: '8px' }} /> 공정 BOM 등록</>)
        action = addProcessBOM;
      } else{
        setModalTitle(<><FaIndustry style={{ marginRight: '8px' }} /> 공정 BOM 수정</>)
        action = updateProcessBOM;
      }
    } else {
      return;
    }
    setIsOpen(true);
    setContent(
    <CrudModal
      type={type}
      formFields={formFields}
      formDatas={row || {}}
      onClose={closeModal}
      onSubmit={action}
    />);
  };
  const openFileModal = (row) => {
    if (!row) {
      return;
    }
    
    setIsOpen(true);
    setContent(
      <FileManagement
        row={row}
        fileCode={"Contract"}
        onClose={closeModal} 
      />);
    setModalTitle(<><PiFloppyDiskBold size={20} style={{ marginRight: '8px' }} /> 첨부파일 관리</>);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const searchProcess = (params = {}) => {
    params.companySeq = session.companySeq;
    dispatch(processApi.request.get(params));
  };
  const addProcess = async (data) => {
    data.companySeq = session.companySeq
    const res = await processApi.request.post(data);
    if (res) {
      searchProcess({ companySeq: session.companySeq, page: currentPage, size: 10 });
    }
    return res;
  };
  const updateProcess = async (data) => {
    data.companySeq = session.companySeq
    const res = await processApi.request.put(data);
    if(res){
      searchProcess({ companySeq: session.companySeq, page: currentPage, size: 10 });
    }
    return res;
  };
  const deleteProcess = async (row) => {
    const params = [row.processSeq]
    await processApi.request.delete(params)
    searchProcess({ companySeq: session.companySeq, page: currentPage, size: 10 });
  };

  const processPaging = (page) => {
    setCurrentPage(page);
    const parmas = {
      page : page,
      size : 10
    }
    searchProcess(parmas)
  }

const processBOMPaging = (page) => {
    const parmas = {
      companySeq : session.companySeq,
      processSeq : clickedRow.processSeq,
      page : page,
      size : 10
    }
    searchProcessBOM(parmas)
  }

  const searchProcessBOM = (params) => {
    dispatch(processBOMApi.request.get(params));
  } 
  const addProcessBOM = async (data) => {
    data.companySeq = session.companySeq
    data.processSeq = clickedRow.processSeq
    await processBOMApi.request.post(data);
    searchProcessBOM({
      companySeq: session.companySeq,
      processSeq: clickedRow.processSeq
    });
  }
  const updateProcessBOM = async (data) => {
    data.companySeq = session.companySeq
    data.processSeq = clickedRow.processSeq
    await processBOMApi.request.put(data);
    searchProcessBOM({
      companySeq: session.companySeq,
      processSeq: clickedRow.processSeq
    });
  };
  const deleteProcessBOM = async (row) => {
    const params = [row.processBOMSeq]
    await processBOMApi.request.delete(params)
    searchProcessBOM({
      companySeq: session.companySeq,
      processSeq: clickedRow.processSeq
    });
  };

  const handleProductRowClick = async (row) => {
    if (!row.processSeq) {
      console.error('Invalid producProct row:', row);
      return;
    }
    if (clickedRow && clickedRow.processSeq === row.processSeq) {
      setClickedRow(null);
      return;
    }
    setClickedRow(row)
  };

  useEffect(() => {
    try {
      let params = {
        companySeq: session.companySeq,
        page: 1,
        size: 10
      };
      searchProcess(params);
    } catch (error) {
      console.error('Error fetching Product : ', error);
    } finally {
      //setIsLoading(false);
    }
  }, [dispatch, session]);

  useEffect(() => {
    if (!clickedRow) return;
    const params = {
      companySeq: session.companySeq, 
      processSeq: clickedRow.processSeq,
      size: 100
    };
    try {
      searchProcessBOM(params);
    } catch (error) {
      console.error('Error fetching process data:', error);
    }
}, [clickedRow]);

  // type : 1 = 공정 , 2 공정 BOM
  const promptDelete = useCallback((type, row) => {
    if ( !row || !type ) {
      return;
    }
    let massge;
    setModalTitle(<><FaInfo style={{ marginRight: '8px' }} /> 알림</>);

    switch (type) {
        case 1 : massge = `"${row.processName}"을 삭제하시겠습니까?`;
        break;
        case 2 : massge = `"${row.materialName}"을 삭제하시겠습니까?`;
        break;
        default: return;
    }

    setContent(
      <ConfirmModal
        message={massge}
        onConfirmAction={() => {
          deleteProcess(row);
          closeModal(); 
        }}
        onCancelAction={closeModal} 
        confirmText="삭제"
        cancelText="취소"
      />);
    setIsOpen(true); 
  }, [deleteProcess, closeModal]);

  const handleExcelDownload = async () => {
    await processDirectApi.process.download({ companySeq: session.companySeq });
  };

  const handleExcelUpload = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls';
    input.onchange = async () => {
      const files = Array.from(input.files || []);
      if (files.length === 0) return;
      const formData = new FormData();
      formData.append('file', files[0]);
      try {
        const result = await processDirectApi.process.import(formData);
        if (result && result.data) {
          setImportResult(result.data);
          setImportResultOpen(true);
        }
        searchProcess({ companySeq: session.companySeq, page: currentPage, size: 10 });
      } catch (e) {
        alert('엑셀 업로드 실패');
      }
    };
    input.click();
  };

  return (
    <div className="process-management">
      <Search
          search={searchProcess}
          formFields={processSearchFormFields}
      />
      <Table
        columns={ processColumns(openModal, promptDelete, openFileModal)}
        data={ process.data }
        page={ process.page }
        title={ <><FaIndustry style={{ marginRight: '8px' }} /> 공정 목록</> }
        onRowClick={ handleProductRowClick }
        // showCheckbox={true}
        onAddClick={() => openModal(1, 1)}
        paging={ processPaging }
        showSearchBar={false}
        excelExport={handleExcelDownload}
        excelImport={handleExcelUpload}
      />
      
      { clickedRow && (
        <Table
          title={ <><FaIndustry style={{ marginRight: '8px' }} /> 공정 BOM</> }
          className="contact-person-table"
          columns={ processBOMColumns(openModal, promptDelete) } 
          data={ processBOM.data }
          page={ processBOM.page }
          onAddClick={() => openModal(1, 2)}
          paging={ processBOMPaging }
          showSearchBar={false}
        />
      )}
      <BaseModal
        children={content}
        title={ modalTitle }
        isOpen={ isOpen }
        onClose={closeModal}
      />
      <ExcelImportResultModal
        isOpen={importResultOpen}
        onClose={() => setImportResultOpen(false)}
        result={importResult}
      />
    </div>
  );
};

export default ProcessManagement;
